import { instanceOfErrorListResponse } from '@genial/services';
import type { ErrorListResponse } from '@genial/services';
import { useEffect } from 'react';

import { useRecoilQuery } from '../../../hooks/useRecoilQuery';
import { useToastCreator } from '../../../hooks/useToastCreator';
import { batchTicketRedeemBaseFileQuery } from '../../../store/batchTicket/selectors/redeem';

export const useSpreadsheetRequests = () => {
  const {
    data: response,
    error,
    loading,
    refresher,
  } = useRecoilQuery(batchTicketRedeemBaseFileQuery, { cachePolicy: 'no-cache' });

  const data = response?.data;
  const hasData = !!(data && data?.length > 0);

  const { showToastFromError } = useToastCreator('redeem-batch-ticket-requests-toast');

  const updateButtonIsDisabled = loading;

  useEffect(() => {
    if (error) {
      if (instanceOfErrorListResponse(error)) {
        (error as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
          showToastFromError(errorItem)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return {
    updateButtonIsDisabled,
    data,
    hasData,
    handleRefreshSpreadsheetRequests: refresher,
    isLoading: loading,
  };
};
